import { devtools } from 'zustand/middleware'

import type { StateCreator } from './store'

/**
 * Adds Redux devtools.
 * https://github.com/pmndrs/zustand#redux-devtools
 */
export const addDevtool = (creator: StateCreator): StateCreator => {
  return devtools(creator, {
    name: 'FWN EmbedFeed Widget',
  }) as StateCreator
}
